<template>
  <div class="auth">
    <div class="auth__bg">
        <svg width="1500" height="1074" viewBox="0 0 1000 716" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <defs>
        <linearGradient id="g1" y2="100%">
          <stop stop-color="#303476"/>
          <stop offset="1" stop-color="#25275a"/>
        </linearGradient>
        <filter id="b" x="-17" y="-8" width="1100" height="724" filterUnits="userSpaceOnUse">
        <feOffset dy="4" in="SourceAlpha" result="offset"/>
        <feGaussianBlur result="blur" stdDeviation="2.828"/>
        <feFlood flood-opacity=".52" result="flood"/>
        <feComposite in2="blur" operator="in" result="composite"/>
        <feBlend in="SourceGraphic" result="blend"/>
        </filter>
        </defs>
        <path fill="url(#g1)" class="cls-1" d="M1030,58c3.66,1.279,60.81-61.713,36.3-60.924C926.85,1.571,410-1,410-1H0L-1,595S-12.968,705.882-5.03,701.893c254.49-127.866,332.29-28.44,481.292-66.323,141.37-35.943,89.424-237.565,213.962-229.187C953.861,424.118,826.333,64.835,1031.31,57.228" data-name="Фигура 1"/>
        </svg>
    </div>
    <div class="auth__logo-wrapper">
      <div class="auth__logo"><img src="/static/img/logo.png" alt=""></div>
      <form @submit.prevent="auth" class="auth__form-group">
        <div class="auth__title">Вход</div>
          <div class="auth__input">
            <input v-model="login" placeholder="Логин" required>
            <svg class="auth__input-image" width="184" height="184" viewBox="0 0 184 183.999" xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(-120.01 -54)">
                <path d="M212.007,54a91.955,91.955,0,0,0-63.118,158.869,9.892,9.892,0,0,0,1.074,1,91.827,91.827,0,0,0,124.086,0,10,10,0,0,0,1.074-1A91.954,91.954,0,0,0,212.007,54Zm0,164a71.615,71.615,0,0,1-43.491-14.668,50,50,0,0,1,86.982,0A71.617,71.617,0,0,1,212.007,218Zm-16-76v-6.5a16,16,0,0,1,32,0V142a16,16,0,0,1-32,0Zm73.94,46.683a69.375,69.375,0,0,0-29.463-24.7A35.811,35.811,0,0,0,248.007,142v-6.5a36,36,0,0,0-72,0V142a35.811,35.811,0,0,0,7.523,21.986,69.375,69.375,0,0,0-29.463,24.7,72,72,0,1,1,115.88,0Z"/>
              </g>
            </svg>
          </div>
          <div class="auth__input">
            <input id="custom" v-model="password" type="password" placeholder="Пароль" required>
            <svg class="auth__input-image" enable-background="new 0 0 512 512" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
              <circle cx="370" cy="346" r="20"/>
              <path d="m460 362c11.046 0 20-8.954 20-20v-74c0-44.112-35.888-80-80-80h-24.037v-70.534c0-64.771-53.832-117.47-120-117.47s-120 52.695-120 117.47v70.534h-23.963c-44.112 0-80 35.888-80 80v164c0 44.112 35.888 80 80 80h288c44.112 0 80-35.888 80-80 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 22.056-17.944 40-40 40h-288c-22.056 0-40-17.944-40-40v-164c0-22.056 17.944-40 40-40h288c22.056 0 40 17.944 40 40v74c0 11.046 8.954 20 20 20zm-124.04-174h-160v-70.534c0-42.715 35.888-77.466 80-77.466s80 34.751 80 77.466v70.534z"/>
              <circle cx="219" cy="346" r="20"/>
              <circle cx="144" cy="346" r="20"/>
              <circle cx="294" cy="346" r="20"/>
            </svg>
          </div>
        <button btnType="submit">Войти</button>
      </form>
      <div class="auth__text-ph">
        <span>Android</span>
        <span>Compile</span>
        <span>Service</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from '../api'

export default {
  name: "Auth",
  components: {
  },
  data () {
    return {
      login: '',
      password: '',
      hasMessages: false
    }
  },
  methods: {
    auth: function () {
      const { login, password } = this;
      Auth.login(this.$API, { login, password })
        .then(() => {
          this.$router.push('/home')
        })
    }
  },
  computed: {
      messageClass () {
        return {
          'md-invalid': this.hasMessages
        }
      }
    }
}

</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
.auth {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 5px;
  max-height: 100vh;
  overflow: hidden;
  background-color: white;
  font-family: 'Montserrat', UILanguageFont, sans-serif;

  @media only screen
  and (min-width: 320px)
  and (max-width: 1400px) {
    background: linear-gradient(135deg, rgba(48,52,117,1) 0%, rgba(41,44,101,1) 100%);
    padding: 0;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 1312px;
      height: 1054px;
      mix-blend-mode: darken;
      background: url("/static/img/ax-bg.png") center center no-repeat;
    }

    svg {
      width: 100%;
      height: auto;
      max-height: 100vh;
      filter: drop-shadow( 0 5px 5px gray);

      @media only screen
        and (min-width: 320px)
        and (max-width: 1400px) {
         display:none;
      }
    }

    @media only screen
    and (min-width: 320px)
    and (max-width: 780px) {
      display: none;
    }
  }

  &__logo-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    z-index: 1;
    padding: 2% 0 2% 2%;

    @media only screen
    and (min-width: 320px)
    and (max-width: 780px) {
      justify-content: space-around;
      padding: 0;
    }
  }

  &__logo {
    position: relative;
    width: 122px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__text-ph {
    position: relative;
    display: flex;
    flex-direction: column;

    span {
      color: black;
      font-size: 80px;
      font-weight: bold;
      // filter: drop-shadow( 0 2px 1px black);

     &:first-letter {
        color: #3d3df3;
      }

      @media only screen
        and (min-width: 320px)
        and (max-width: 1400px) {
          display: none;
      }
    }

    span:first-child{
      color: white;
    }

    @media only screen
    and (min-width: 320px)
    and (max-width: 780px) {
      display: none;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 400;
    color: white;
  }

  &__form-group {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 400px;
    height: 300px;
    width: 100%;
    padding: 40px;
    border: none;
    border-left: 4px solid #3d3df3;

    input {
      position: relative;
      height: 50px;
      width: 230px;
      padding: 0 25px 0 5px;
      border: 2px solid white;
      border-top-right-radius: 4px;
	    border-bottom-right-radius: 4px;
      background: rgba(255,255,255, 0);
      font-weight: 600;
      font-size: 13px;
      outline: none;
      transform: scale(1);
      transition: all 200ms;
      color: white;
      font-size: 16px;

      &::placeholder {
        color: white;
      }

        &:focus {
            border: none;
            border-left: 2px solid #3d3df3;
            background: rgba(255,255,255, 1);
            width: 330px;
            color: black;

            @media only screen
              and (min-width: 320px)
              and (max-width: 780px) {
                width: 240px;
              }

        }
    }

    input:focus + .auth__input-image path {
        fill: #3d3df3;
    }
    input:focus + .auth__input-image circle {
        fill: #3d3df3;
    }

    button {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      min-width: 100px;
      height: 50px;
      background-color: white;
      border:none;
      border-left: 2px solid #3a3bf8;
      border-top-right-radius: 4px;
	    border-bottom-right-radius: 4px;
      box-shadow: 0px 5px 10px -1px rgba(0, 0, 0, 0.25);
      color: black;
      cursor: pointer;
      transition: all 300ms;
      outline: none;

      &:hover {
        border-left: 2px solid white;
        background-color: #3a3bf8;
        color: white;
        padding-left: 50px;
        padding-right: 50px;
      }
    }
  }

  &__input {
    position: relative;
    display: flex;
  }

  &__input-image {
    position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 25px;
        width: 20px;
        height: 20px;
        pointer-events: none;

        path {
          fill: white;
          transition: all 200ms;
        }

        circle{
            fill: white;
            transition: all 200ms;
        }
  }
}
</style>
